import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
export default {
	data(){
		return {
			recommendImg: []
		}
	},
	methods: {
		async getRecommendImg(){
			let param = {
				searchKeyWord: this.keyWords||'',
				pageSize: this.pageSize
			}
			ajaxParam(param)
			const res = await post('v1/column/getRecommendBanner', qs.stringify(param))
			if(res.data.code==200){
				this.recommendImg = res.data.list
			} else {
				this.$message.error(res.data.msg)
			}
		}
	}
}